<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :width="dialogWidth"
    append-to-body
    @close="onClose"
  >
    <div class="video-player-box">
      <div v-if="loading" class="video-skeleton">
        <div class="video-skeleton-icon"></div>
        <div class="video-skeleton-line"></div>
      </div>
      <video
        ref="videoPlayer"
        :key="src"
        class="video-player"
        :src="src"
        controls
        autoplay
        playsinline
        preload="metadata"
        @loadstart="onLoadStart"
        @loadeddata="onLoaded"
        @canplay="onLoaded"
        @error="onLoaded"
      ></video>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VideoPlayerDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '760px'
    }
  },

  data() {
    return {
      loading: true
    }
  },

  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    },

    dialogWidth() {
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return '92%'
      }
      return this.width
    }
  },

  watch: {
    visible(value) {
      if (value) {
        this.loading = true
        this.$nextTick(this.playVideo)
      }
    },

    src() {
      this.loading = true
      this.$nextTick(this.playVideo)
    }
  },

  methods: {
    onLoadStart() {
      this.loading = true
    },

    onLoaded() {
      this.loading = false
      this.playVideo()
    },

    playVideo() {
      const video = this.$refs.videoPlayer
      if (!this.visible || !video) return

      const playPromise = video.play()
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {})
      }
    },

    onClose() {
      const video = this.$refs.videoPlayer
      if (video) {
        video.pause()
        video.currentTime = 0
      }
      this.loading = true
    }
  }
}
</script>

<style scoped>
.video-player-box {
  position: relative;
  width: 100%;
  background: #111;
  border-radius: 6px;
  overflow: hidden;
  min-height: 260px;
}

.video-player {
  display: block;
  width: 100%;
  max-height: 70vh;
  background: #111;
}

.video-skeleton {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: linear-gradient(110deg, #151515 8%, #242424 18%, #151515 33%);
  background-size: 200% 100%;
  animation: video-skeleton-loading 1.4s ease-in-out infinite;
}

.video-skeleton-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  position: relative;
}

.video-skeleton-icon::after {
  content: '';
  position: absolute;
  top: 17px;
  left: 22px;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  border-left: 16px solid rgba(255, 255, 255, 0.5);
}

.video-skeleton-line {
  width: 42%;
  height: 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
}

@keyframes video-skeleton-loading {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}
</style>
